// import AOS from 'aos';
import Search from '../search';
import MobileMenu from '../mobile-menu';
import Menu from '../menu';
import MobileMenuHeader from '../mobile-menu-header';
import MenuHeader from '../menu-header';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

export default {
  obsever: null,
  observerOptions: {
    attributes: false,
    characterData: false,
    childList: true,
    subtree: true,
  },
  init() {
    /*
    AOS.init({
      duration: 900,
      easing: 'ease-out-cubic',
      delay: 100,
      once: true,
    });
    */

    gsap.registerPlugin(ScrollTrigger);
    this.initBlockControllers();
    this.createBlockControllersObserver();
    this.initSearch();
    this.initScrollTop();
    this.initMobileMenu();
    this.initMenu();
    this.initFormOverlays();
    this.goBack();
    window.addEventListener('load', () => {
      window.document
        .querySelectorAll('[data-src-defer]')
        .forEach((element) => {
          element.src = element.dataset.srcDefer;
        });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },

  initBlockControllers() {
    const initController = this.initController.bind(this);

    document.querySelectorAll('[data-controller]').forEach((blockEl) => {
      initController(blockEl);
    });
  },

  createBlockControllersObserver() {
    const { observerOptions } = this;
    const initController = this.initController.bind(this);

    this.observer = new MutationObserver(function (mutationsList) {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes) {
          mutation.addedNodes.forEach((node) => {
            const isElement = node.nodeType === 1;

            if (isElement && node.dataset.controller) {
              initController(node);
            }
          });
        }
      });
    });

    this.observer.observe(document, observerOptions);
  },

  initController(el) {
    const controllerClass = el.dataset.controller;

    const module = require(`./../${controllerClass}`);
    const Controller = module.default;
    new Controller(el);
  },

  initSearch() {
    new Search();
  },

  goBack() {
    const btn = document.querySelector('[data-action-go-back]');

    if (!btn) {
      return;
    }

    btn.addEventListener('click', (event) => {
      event.preventDefault();
      history.back();
    });
  },

  initScrollTop() {
    const scrollTop = document.querySelector('[data-scroll-top]');

    if (scrollTop) {
      scrollTop.addEventListener('click', () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      });
    }
  },

  initMobileMenu() {
    const mobileMenu = document.querySelector('[data-mobile-menu]');
    const mobileMenuBtn = document.querySelector('[data-mobile-menu-btn]');
    const mobileMenuItemBtns = document.querySelectorAll(
      '[data-mobile-menu-item-btn]'
    );
    const mobileMenuHeader = document.querySelector(
      '[data-mobile-menu-header]'
    );
    const mobileMenuBtnHeader = document.querySelector(
      '[data-mobile-menu-header-btn]'
    );
    const mobileMenuItemBtnsHeader = document.querySelectorAll(
      '[data-mobile-menu-header-item-btn]'
    );

    if (mobileMenu && mobileMenuBtn && mobileMenuItemBtns) {
      new MobileMenu({
        el: mobileMenu,
        btn: mobileMenuBtn,
        btns: mobileMenuItemBtns,
      });
    }

    if (mobileMenuHeader && mobileMenuBtnHeader && mobileMenuItemBtnsHeader) {
      new MobileMenuHeader({
        el: mobileMenuHeader,
        btn: mobileMenuBtnHeader,
        btns: mobileMenuItemBtnsHeader,
      });
    }
  },

  initMenu() {
    const menu = document.querySelector('[data-dropdown-menu]');
    const menuHeader = document.querySelector('[data-dropdown-menu-header]');
    new Menu(menu);
    new MenuHeader(menuHeader);
  },

  initFormOverlays() {
    document.querySelectorAll('[data-action-form]').forEach((ctaEl) => {
      ctaEl.addEventListener('click', (event) => {
        event.preventDefault();
        const formId = ctaEl.dataset.actionForm;
        document.querySelector('body').classList.add('no-scroll');
        document
          .querySelector(`[data-form-id="${formId}"]`)
          .classList.add('js--active');
      });
    });
    document
      .querySelectorAll('[data-action="hubspot-form-close"]')
      .forEach((closeEl) => {
        closeEl.addEventListener('click', (event) => {
          event.preventDefault();
          closeEl.closest('[data-form-id]').classList.remove('js--active');
          document.querySelector('body').classList.remove('no-scroll');
        });
      });
    setTimeout(() => {
      document
        .querySelectorAll('[data-role="hs-form"] iframe')
        .forEach((formIframeEl) => {
          const submitEl = formIframeEl.contentDocument.querySelector(
            'input[type="submit"]'
          );
          if (!submitEl) {
            return;
          }
          submitEl.addEventListener('click', () => {
            if (window.gtag) {
              window.gtag('event', 'conversion', {
                send_to: 'AW-1071383928/t7tTCM3VsbYYEPiK8P4D',
              });
            }
          });
        });
    }, 5000);
  },
};
